import { SalesGroupDeeplinkQueryParam } from 'src/utils/constants/constants';
import { getDeepLinkIdFromUrl } from 'src/utils/deepLinkUtils';

import { SalesGroupModal } from './SalesGroupModal';

const SalesGroupModalDeepLinkConsumer = () => {
  const salesGroupId = getDeepLinkIdFromUrl(
    SalesGroupDeeplinkQueryParam,
    window.location.href
  );

  if (!salesGroupId) {
    return null;
  }

  return <SalesGroupModal salesGroupId={String(salesGroupId)} />;
};

export const SalesGroupModalConfig = {
  children: <SalesGroupModalDeepLinkConsumer />,
  clickOutsideToClose: true,
  deepLinkKey: SalesGroupDeeplinkQueryParam,
  deepLinkValue: undefined as string | undefined,
  size: 'slide-in',
};

export const getSalesGroupModalConfigWithDeepLink = (
  salesGroupId?: string | null
) => ({
  ...SalesGroupModalConfig,
  deepLinkValue: salesGroupId ?? undefined,
  children: <SalesGroupModal salesGroupId={String(salesGroupId ?? '')} />,
});
